module.exports = "/images/SelfHero.jpg";